module.exports = "/assets/03cf3007791e7aefe4931043fde632ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ET.png
// module id = 760
// module chunks = 0